import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

export interface CreateUserPayload {
	name: string;
	surName: string;
	email: string;
	phoneNumber?: string;
	status: boolean;
	planId?: string;
	document?: string;
	documentType?: string;
	avatarFile?: File;
}

export const useCreateUser = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ avatarFile, ...data }: CreateUserPayload) => {
			try {
				const form = createFormData({ ...data, avatar: avatarFile });
				return (await api.post('/management/user/create', form)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar usuário');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['users'] });
		},
		onError: error => console.error('Erro ao criar usuário:', getApiErrorMessage(error, 'Erro ao criar usuário')),
	});
};
